import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Permission } from "../models/permission.model";
import { PermissionTable } from "../models/permission-table.model";

export namespace PermissionActions {

  @logDispatcher
  export class GetPermissions {
    static readonly type = '[Permission] GetPermissions';
    constructor() {}
  }
  
  @logDispatcher
  export class GetPermissionsSuccess {
    static readonly type = '[Permission] GetPermissionsSuccess';
    constructor(public permissions: Permission[]) {}
  }

  @logDispatcher
  export class EditTableCell {
    static readonly type = "[Permission] EditTableCell"
    constructor(public levelPermissionId: string, public level: string, public isChecked: boolean) {}
  }

  @logDispatcher
  export class ExpandTableRow {
    static readonly type = "[Permission] ExpandTableRow"
    constructor(public levelPermissionId: string) {}
  }

  @logDispatcher
  export class UpdatePermission {
    static readonly type = '[Permission] UpdatePermission';
    constructor() {}
  }

  @logDispatcher
  export class UpdatePermissionSuccess {
    static readonly type = '[Permission] UpdatePermissionSuccess';
    constructor() {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Permission] Error';
    constructor(public error: any) {}
  }

  @logDispatcher
  export class SetConfigurationDefaultState  {
      static readonly type = '[Permission] SetConfigurationDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetDefaultState  {
      static readonly type = '[Permission] SetDefaultState';
      constructor() {}
  }
}